import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABanner({
  eyebrow = "Pojďme se nezávazně bavit",
  title = "O vašem účetnictví. V klidu, bez tlaku.",
  text = "Stačí krátká schůzka — řekneme si, co potřebujete, a navrhneme řešení šité na míru vaší firmě.",
  primaryHref = "/kontakt",
  primaryLabel = "Napsat nám",
  secondaryHref,
  secondaryLabel,
}) {
  return (
    <section className="px-6 md:px-12 py-16">
      <div className="max-w-7xl mx-auto bg-ink2 text-white rounded-lg overflow-hidden">
        <div className="px-8 md:px-16 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10 items-end relative">
          <div className="absolute inset-0 opacity-[0.06] bg-grid pointer-events-none" />
          <div className="md:col-span-8 relative">
            <span className="text-xs tracking-[0.2em] uppercase text-magenta font-semibold">
              {eyebrow}
            </span>
            <h2 className="font-display text-3xl md:text-5xl tracking-tight font-medium mt-4 leading-[1.1]">
              {title}
            </h2>
            {text && (
              <p className="mt-6 text-base md:text-lg text-white/70 leading-relaxed max-w-xl">
                {text}
              </p>
            )}
          </div>
          <div className="md:col-span-4 relative flex md:justify-end gap-3 flex-wrap">
            <Link
              to={primaryHref}
              data-testid="ctabanner-primary"
              className="inline-flex items-center gap-2 bg-magenta hover:bg-magenta-dark text-white px-7 py-4 rounded-full font-medium transition-colors"
            >
              {primaryLabel}
              <ArrowRight className="w-4 h-4" />
            </Link>
            {secondaryHref && (
              <Link
                to={secondaryHref}
                data-testid="ctabanner-secondary"
                className="inline-flex items-center gap-2 border border-white/40 hover:border-magenta hover:text-magenta text-white px-7 py-4 rounded-full font-medium transition-colors"
              >
                {secondaryLabel}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
